import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiQuote } = FiIcons;

const testimonials = [
  {
    name: "Sarah Mitchell",
    title: "CEO, TechStart Solutions",
    rating: 5,
    text: "John Fagerholm saved our company from a frivolous lawsuit that could have destroyed us. His aggressive defense and deep knowledge of California employment law was exactly what we needed."
  },
  {
    name: "Michael Rodriguez",
    title: "Owner, Rodriguez Manufacturing",
    rating: 5,
    text: "After 15 years of running my business, I finally found a lawyer who truly understands what employers face. John fights hard for business owners and gets results."
  },
  {
    name: "Jennifer Chen",
    title: "Founder, Digital Marketing Pro",
    rating: 5,
    text: "The peace of mind knowing John is protecting our business is invaluable. His proactive approach has prevented multiple potential issues before they became problems."
  },
  {
    name: "David Thompson",
    title: "President, Thompson Construction",
    rating: 5,
    text: "John's exclusive focus on representing employers means he knows exactly how to protect our interests. His 30+ years of experience shows in every interaction."
  },
  {
    name: "Lisa Wang",
    title: "COO, InnovateTech",
    rating: 5,
    text: "We've worked with several employment lawyers, but none compare to John's aggressive advocacy for business owners. He truly understands the challenges we face in California."
  }
];

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What California Business Owners Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See why hundreds of California businesses trust John Fagerholm to aggressively defend 
            their interests against unfair labor laws and frivolous employee claims.
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiQuote} className="text-3xl text-blue-600 mr-3" />
                <div className="flex">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-lg fill-current" />
                  ))}
                </div>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              <div className="border-t pt-4">
                <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                <p className="text-gray-600 text-sm">{testimonial.title}</p>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mt-8 max-w-4xl mx-auto">
          {testimonials.slice(3, 5).map((testimonial, index) => (
            <motion.div
              key={index + 3}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: (index + 3) * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiQuote} className="text-3xl text-blue-600 mr-3" />
                <div className="flex">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-lg fill-current" />
                  ))}
                </div>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              <div className="border-t pt-4">
                <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                <p className="text-gray-600 text-sm">{testimonial.title}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;